import React from 'react'
import { Link } from 'react-router-dom'

function TitleContainer({
  path,
  title,
  action,
  children,
  className,
}) {
  return (
    <div className={`w-full ${className}`}>
      <div className='md:flex justify-between items-center p-5'>
        <p className='text-lg font-semibold text-blue'>{title}</p>
        {action}
        <Link hidden={!path} to={path} className='px-3 py-1.5 rounded-md border border-light_blue text-xs font-medium text-dim'>View All</Link>
      </div>
      <div className='w-full'>{children}</div>
    </div>
  )
}

export default TitleContainer